import React from 'react';
import CalendarPage from './CalendarPage';

/** Dashboard ohne Kampagnen — Kalender bleibt die Übersicht. */
const Dashboard = () => <CalendarPage />;

export default Dashboard;
